import { render, staticRenderFns } from "./CorrelationTable.vue?vue&type=template&id=1051f0b1"
import script from "./CorrelationTable.vue?vue&type=script&lang=js"
export * from "./CorrelationTable.vue?vue&type=script&lang=js"
import style0 from "./CorrelationTable.vue?vue&type=style&index=0&id=1051f0b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports